var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.resetLinkSuccessMsg
        ? _c("div", { staticClass: "text-green" }, [
            _vm._v(_vm._s(_vm.resetLinkSuccessMsg))
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class:
            "user_offcanvas_header text-left " +
            (_vm.readOnly ? "readonly_users_heading_1" : "users_heading_1")
        },
        [
          _vm._v("\n        " + _vm._s(_vm.card_title) + " "),
          _vm.count > 0
            ? _c("span", [_vm._v(" - " + _vm._s(_vm.count))])
            : _vm._e(),
          _vm._v("   \n        "),
          _vm.itemLength > 3 && _vm.count > 0
            ? _c(
                "a",
                {
                  staticClass: "see-more",
                  attrs: { href: "javascript:void(0)" },
                  on: { click: _vm.clickShowMore }
                },
                [_vm._v(_vm._s(_vm.see_more_text))]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass: "user_offcanvas_header users_heading_2 text-center"
            },
            [_vm._v("Password ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.readOnly && _vm.isCanAddTransfer == true
        ? _c(
            "div",
            {
              staticClass: "user_offcanvas_header users_heading_3 text-center"
            },
            [_vm._v("Add/Transfer ")]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.readOnly
        ? _c(
            "div",
            {
              staticClass: "user_offcanvas_header users_heading_4 text-center"
            },
            [_vm._v("Status ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "clearfix" }),
      _vm._v(" "),
      _vm.loading == true
        ? _c(
            "div",
            { staticClass: "text-center pt-4" },
            _vm._l(5, function(option) {
              return _c("div", { staticClass: "row ml-1" }, [
                _c(
                  "div",
                  {
                    staticClass: "users_heading_1",
                    staticStyle: { "padding-left": "0px" }
                  },
                  [_c("PuSkeleton", { attrs: { count: 1 } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "users_heading_2",
                    staticStyle: { "padding-left": "10px" }
                  },
                  [_c("PuSkeleton", { attrs: { count: 1 } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "users_heading_3",
                    staticStyle: { "padding-left": "10px" }
                  },
                  [_c("PuSkeleton", { attrs: { count: 1 } })],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "users_heading_4",
                    staticStyle: { "padding-left": "10px" }
                  },
                  [_c("PuSkeleton", { attrs: { count: 1 } })],
                  1
                ),
                _vm._v(" "),
                _vm._m(0, true)
              ])
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more === false && _vm.count > 0
        ? _c(
            "div",
            _vm._l(_vm.lessResult, function(user, uindex) {
              return _c(
                "div",
                { key: uindex, staticClass: "col-12 users_lists" },
                [
                  _c(
                    "div",
                    {
                      class:
                        "user_offcanvas_content text-left " +
                        (_vm.readOnly
                          ? "readonly_users_heading_1"
                          : "users_heading_1"),
                      on: {
                        click: function($event) {
                          return _vm.goToUserDetail(user.id)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "uname" }, [
                        _vm._v(
                          _vm._s(
                            _vm.capitalizeFirstLetter(user.first_name) +
                              " " +
                              _vm.capitalizeFirstLetter(user.last_name)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "uemail" }, [
                        _vm._v(_vm._s(user.email))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.readOnly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_2 text-center"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "offcanvas_link",
                              on: {
                                click: function($event) {
                                  return _vm.openResetLinkModal(user)
                                }
                              }
                            },
                            [_vm._v(" Reset")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readOnly &&
                  _vm.isCanAddTransfer == true &&
                  user.status == "Active"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_3 text-center"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "offcanvas_link",
                              on: {
                                click: function($event) {
                                  return _vm.openTransferLinkModal(user)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/enterprise/Move_User_16x16.png")
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : !_vm.readOnly && _vm.isCanAddTransfer == true
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_3 text-center"
                        },
                        [_vm._v("\n                 \n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readOnly &&
                  (_vm.card_title == "Mentees" ||
                    _vm.card_title == "Apprentices")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_4 text-center"
                        },
                        [
                          user.status == "Active"
                            ? _c(
                                "a",
                                {
                                  class:
                                    "status_link " +
                                    _vm.getFontColor(user.status),
                                  attrs: { id: "user-" + user.id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openStatusModal(user)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formatStatus(user.status))
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : !_vm.readOnly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_4 text-center"
                        },
                        [
                          _c(
                            "a",
                            {
                              class:
                                "status_link " + _vm.getFontColor(user.status),
                              attrs: { id: "user-" + user.id },
                              on: {
                                click: function($event) {
                                  return _vm.openStatusModal(user)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.formatStatus(user.status))
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.show_more === true && _vm.count > 0
        ? _c(
            "div",
            _vm._l(_vm.allItems, function(user, uindex) {
              return _c(
                "div",
                { key: uindex, staticClass: "col-12 users_lists" },
                [
                  _c(
                    "div",
                    {
                      class:
                        "user_offcanvas_content text-left " +
                        (_vm.readOnly
                          ? "readonly_users_heading_1"
                          : "users_heading_1"),
                      on: {
                        click: function($event) {
                          return _vm.goToUserDetail(user.id)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "uname" }, [
                        _vm._v(
                          _vm._s(
                            _vm.capitalizeFirstLetter(user.first_name) +
                              " " +
                              _vm.capitalizeFirstLetter(user.last_name)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "uemail" }, [
                        _vm._v(_vm._s(user.email))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  !_vm.readOnly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_2 text-center"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "offcanvas_link",
                              on: {
                                click: function($event) {
                                  return _vm.openResetLinkModal(user)
                                }
                              }
                            },
                            [_vm._v(" Reset")]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readOnly &&
                  _vm.isCanAddTransfer == true &&
                  user.status == "Active"
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_3 text-center"
                        },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "offcanvas_link",
                              on: {
                                click: function($event) {
                                  return _vm.openTransferLinkModal(user)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/enterprise/Move_User_16x16.png")
                                }
                              })
                            ]
                          )
                        ]
                      )
                    : !_vm.readOnly && _vm.isCanAddTransfer == true
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_3 text-center"
                        },
                        [_vm._v("\n                 \n            ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.readOnly &&
                  (_vm.card_title == "Mentees" ||
                    _vm.card_title == "Apprentices")
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_4 text-center"
                        },
                        [
                          user.status == "Active"
                            ? _c(
                                "a",
                                {
                                  class:
                                    "status_link " +
                                    _vm.getFontColor(user.status),
                                  attrs: { id: "user-" + user.id },
                                  on: {
                                    click: function($event) {
                                      return _vm.openStatusModal(user)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.formatStatus(user.status))
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    : !_vm.readOnly
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "user_offcanvas_content users_heading_4 text-center"
                        },
                        [
                          _c(
                            "a",
                            {
                              class:
                                "status_link " + _vm.getFontColor(user.status),
                              attrs: { id: "user-" + user.id },
                              on: {
                                click: function($event) {
                                  return _vm.openStatusModal(user)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.formatStatus(user.status))
                              )
                            ]
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" })
                ]
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row_item_readonly justify-content-md-center" },
        [
          _c("div", { staticClass: "text-red text-center m-4" }, [
            _vm._v(_vm._s(_vm.getNoRecordText(_vm.count, _vm.card_title)))
          ])
        ]
      ),
      _vm._v(" "),
      _c("ResetLinkModal", {
        ref: "reset_modal_popup",
        attrs: { isModalVisible: _vm.isResetLinkModal },
        on: { close: _vm.closeResetLinkModal }
      }),
      _vm._v(" "),
      _c("UserActivateModal", {
        ref: "user_activate_modal",
        attrs: {
          isModalVisible: _vm.isUserActivateModal,
          page_from: "user_list"
        },
        on: { close: _vm.closeUserActivateModal }
      }),
      _vm._v(" "),
      _c("UserInactivateModal", {
        ref: "user_inactivate_modal",
        attrs: {
          isModalVisible: _vm.isUserInactivateModal,
          page_from: "user_list"
        },
        on: { close: _vm.closeUserInactivateModal }
      }),
      _vm._v(" "),
      _c("AddTransferLinkModal", {
        ref: "add_transfer_modal_popup",
        attrs: {
          isModalVisible: _vm.isTransferLinkModal,
          accountId: _vm.accountId
        },
        on: { close: _vm.closeTransferLinkModal }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 p-0" }, [
      _c("div", { staticClass: "custom_hr" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d2d0f5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2d0f5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/location_users_list.vue
// module id = null
// module chunks = 